import { useMemo } from "react";
import { useDigitalMenuConfig } from "@swiggy-private/portal-dineout-context";
import { useIsV2InApp } from "./useIsV2InApp";

export const useConfigTheme = () => {
    const { config } = useDigitalMenuConfig();
    const { isV2InApp } = useIsV2InApp();
    return useMemo(() => (isV2InApp ? config?.themeInfo?.theme : undefined), [isV2InApp, config?.themeInfo?.theme]);
};
